import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button, { isButtonEnabled } from 'src/components/design-system/Button';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const DeleteItem: FC<GridCellProps> = (props) => {
  const { dataItem, dataIndex } = props;
  const setSplitLineItem = useContextSelector(InvoiceContext, (value) => value.setSplitLineItem);

  const handleClick = useCallback(() => {
    setSplitLineItem((prev) => {
      const lineItems = [...prev];
      lineItems?.splice(dataIndex, 1);
      return lineItems;
    });
  }, [dataIndex, setSplitLineItem]);

  return (
    <GridCellBase {...props}>
      {(isButtonEnabled(dataItem?.canDelete) || dataItem?.isNewLineItem) && (
        <Button color="error" onClick={handleClick}>
          Delete
        </Button>
      )}
    </GridCellBase>
  );
};

export default DeleteItem;
